import React, { useState, useContext, useEffect } from "react";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

import StrixhavenSchool from "../playerprofiles/StrixhavenSchool";

import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import CheckActive from "./CheckActive";
import PlayerSelect from "./PlayerSelect";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

export default function PlayerData({ data, dataFields }) {
   const theme = useTheme();

   const forceLineBreak = (text) => {
      if (text) {
         let textArray = text.split(" ");
         let divider = textArray.length === 2 ? "<br />" : " ";
         let response = textArray.join(divider);
         return <div dangerouslySetInnerHTML={{ __html: response }} />;
      }
   };

   const lang = (text) => {
      switch (text) {
         case "STARTED_IN":
            return "Started In";
            break;
         case "TOP_FINISHES":
            return "Top Finishes";
            break;
         case "REGIONAL_TOP_FINISHES":
            return "Regional Top Finishes";
            break;
         case "PTS_THIS_SEASON":
            return "2024&nbsp;Pro Tours";
            break;
         case "PREFERRED_PRONOUNS":
            return "Pronouns";
            break;
         case "STRIXHAVEN_SCHOOL":
            return "Strixhaven School";
            break;
         case "TEAM":
            return "Team";
            break;
         default:
            return text;
      }
   };

   return (
      <>
         {data && (
            <>
               {dataFields &&
                  dataFields.data.map((row, i) => (
                     <Box key={"field" + i} sx={{ height: 130 }}>
                        <Typography
                           variant='h2head2headtitle'
                           component='div'
                           sx={{ textTransform: "uppercase" }}
                        >
                           {forceLineBreak(lang(row.title))}
                        </Typography>
                        {row.field === "STRIXHAVEN_SCHOOL"
                           ? 
                           <Typography variant='h2head2headvalue' component='div'>
                              <StrixhavenSchool school={data[row.field]} iconWidth={48} />
                           </Typography>
                           :
                           <Typography variant='h1head2headvalue' component='div'>
                              {data[row.field]}
                           </Typography>
                        }
                     </Box>
                  ))}
            </>
         )}
      </>
   );
}
